module.exports = __webpack_public_path__ + "img/link.e9e0b090.svg";